// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Inputs-Forms-styles___button--BXMyb {
  width: 100%;
}

.components-Inputs-Forms-styles___inputContainer--hychX {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.components-Inputs-Forms-styles___inputContainer--hychX > * {
    flex: 48% 0 1;
  }`, "",{"version":3,"sources":["webpack://./components/Inputs/Forms/styles.pcss"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAIhC;;AAHE;IACE,aAAa;EACf","sourcesContent":[".button {\n  width: 100%;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  > * {\n    flex: 48% 0 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `components-Inputs-Forms-styles___button--BXMyb`,
	"inputContainer": `components-Inputs-Forms-styles___inputContainer--hychX`
};
module.exports = ___CSS_LOADER_EXPORT___;
